/** Cache Control scope */
export var CacheControlScope;
(function (CacheControlScope) {
    /**
     * If a cached response has a PRIVATE scope, its value is accessible by only a single user.
     * To enforce this restriction, the cache needs to know how to identify that user.
     * @see: https://www.apollographql.com/docs/apollo-server/performance/caching/#identifying-users-for-private-responses
     */
    CacheControlScope["Private"] = "PRIVATE";
    /**
     * By default, PUBLIC cached responses are accessible by all users.
     * @see https://www.apollographql.com/docs/apollo-server/performance/caching/#separating-responses-for-logged-in-and-logged-out-users
     */
    CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
/** Determines the order of fetch and merge operations between API and database. */
export var CarlineStructureMode;
(function (CarlineStructureMode) {
    /** Fetch carline structure from the API and merge preview carlines and carline groups from the database. */
    CarlineStructureMode["Automatic"] = "AUTOMATIC";
    /** Fetch carline structure from the database and fill in details from the API. */
    CarlineStructureMode["Manual"] = "MANUAL";
})(CarlineStructureMode || (CarlineStructureMode = {}));
/** @deprecated change mutation not implemented */
export var ChangeType;
(function (ChangeType) {
    ChangeType["Add"] = "ADD";
    ChangeType["Remove"] = "REMOVE";
})(ChangeType || (ChangeType = {}));
export var ConfiguredCarFeatureGroup;
(function (ConfiguredCarFeatureGroup) {
    ConfiguredCarFeatureGroup["Accessories"] = "ACCESSORIES";
    ConfiguredCarFeatureGroup["ExteriorColors"] = "EXTERIOR_COLORS";
    ConfiguredCarFeatureGroup["InteriorTiles"] = "INTERIOR_TILES";
    ConfiguredCarFeatureGroup["Lights"] = "LIGHTS";
    ConfiguredCarFeatureGroup["Rims"] = "RIMS";
    ConfiguredCarFeatureGroup["Seats"] = "SEATS";
    ConfiguredCarFeatureGroup["SteeringWheels"] = "STEERING_WHEELS";
})(ConfiguredCarFeatureGroup || (ConfiguredCarFeatureGroup = {}));
/** configuration states to the corresponding bitflags from the DPU (00000=> */
export var ConfiguredCarFeatureState;
(function (ConfiguredCarFeatureState) {
    ConfiguredCarFeatureState["Available"] = "available";
    ConfiguredCarFeatureState["Changeable"] = "changeable";
    ConfiguredCarFeatureState["InConflict"] = "inConflict";
    ConfiguredCarFeatureState["Selected"] = "selected";
    ConfiguredCarFeatureState["Standard"] = "standard";
})(ConfiguredCarFeatureState || (ConfiguredCarFeatureState = {}));
/** An indication about if a color should be chosen from a brighter or darker color scheme */
export var ContrastThemeHint;
(function (ContrastThemeHint) {
    ContrastThemeHint["Dark"] = "DARK";
    ContrastThemeHint["Light"] = "LIGHT";
})(ContrastThemeHint || (ContrastThemeHint = {}));
/** Possible actions that can be taken with a feature in relation to a ConfiguredCar */
export var FeatureChangeAction;
(function (FeatureChangeAction) {
    FeatureChangeAction["Add"] = "ADD";
    FeatureChangeAction["Remove"] = "REMOVE";
})(FeatureChangeAction || (FeatureChangeAction = {}));
/** @deprecated queries deprecated */
export var IdentifierType;
(function (IdentifierType) {
    IdentifierType["Audicode"] = "AUDICODE";
    IdentifierType["Carline"] = "CARLINE";
    IdentifierType["Prstring"] = "PRSTRING";
})(IdentifierType || (IdentifierType = {}));
/** @deprecated renamed to `ConfiguredCarFeatureGroup` */
export var ItemGroup;
(function (ItemGroup) {
    ItemGroup["Accessories"] = "ACCESSORIES";
    ItemGroup["ExteriorColors"] = "EXTERIOR_COLORS";
    ItemGroup["InteriorTiles"] = "INTERIOR_TILES";
    ItemGroup["Lights"] = "LIGHTS";
    ItemGroup["Rims"] = "RIMS";
    ItemGroup["Seats"] = "SEATS";
    ItemGroup["SteeringWheels"] = "STEERING_WHEELS";
})(ItemGroup || (ItemGroup = {}));
/**
 * TODO; Verify the roles (Complete?)
 * The role of a contact
 */
export var OneGraphServiceContactRoleEnum;
(function (OneGraphServiceContactRoleEnum) {
    /** Role Developer */
    OneGraphServiceContactRoleEnum["Developer"] = "DEVELOPER";
    /**
     * Role Product Owner
     * In an Audi Context an Audi reponsibility
     */
    OneGraphServiceContactRoleEnum["ProductOwner"] = "PRODUCT_OWNER";
    /** Role Proxy Product Owner */
    OneGraphServiceContactRoleEnum["ProxyProductOwner"] = "PROXY_PRODUCT_OWNER";
    /**
     * Support
     * Might be a support contact whithin the service or an exteranl support supplier
     */
    OneGraphServiceContactRoleEnum["Support"] = "SUPPORT";
})(OneGraphServiceContactRoleEnum || (OneGraphServiceContactRoleEnum = {}));
/**
 * Indicates the service status
 * Derived from https://datatracker.ietf.org/doc/html/draft-inadarei-api-health-check-05#section-3.1
 */
export var OneGraphServiceStatusEnum;
(function (OneGraphServiceStatusEnum) {
    /** Failure in Service */
    OneGraphServiceStatusEnum["Fail"] = "FAIL";
    /** Service is ok */
    OneGraphServiceStatusEnum["Pass"] = "PASS";
    /** Warning in Service */
    OneGraphServiceStatusEnum["Warn"] = "WARN";
})(OneGraphServiceStatusEnum || (OneGraphServiceStatusEnum = {}));
/** @deprecated queries deprecated */
export var PriceMode;
(function (PriceMode) {
    PriceMode["Price"] = "PRICE";
    PriceMode["Rate"] = "RATE";
})(PriceMode || (PriceMode = {}));
/** Energy Management for WLTP measurement cycle */
export var WltpEnergyManagement;
(function (WltpEnergyManagement) {
    /** PHEV with with depleted battery measurement */
    WltpEnergyManagement["Depleting"] = "DEPLETING";
    /** Pure fuel measurement, applies for PEV or ICE */
    WltpEnergyManagement["Pure"] = "PURE";
    /** MHEV or PHEV with with full battery measurement */
    WltpEnergyManagement["Sustaining"] = "SUSTAINING";
    /** PHEV (unclear ?) measurement */
    WltpEnergyManagement["Weighted"] = "WEIGHTED";
})(WltpEnergyManagement || (WltpEnergyManagement = {}));
//# sourceMappingURL=types.js.map